// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__PDC6z","buttons":"Footer_buttons__12XBm"};